export default {
  DISCOUNT: 100,
  AMOUNT: 3
}